import classNames from "classnames";
import React from "react";
import styles from "./../../../ricos-common-plugins/gap-spacer/gap-spacer-component/gap-spacer-styles-scss.js";
const GapSpacer = ({ collapsed }) => {
  return /* @__PURE__ */ React.createElement("div", { className: classNames(styles.gapSpacerViewer, { [styles.collapsed]: collapsed }) });
};
export {
  GapSpacer
};
//# sourceMappingURL=gap-spacer.js.map
